import { useEffect } from 'react'
import { currentAdminCan } from '../data/currentAdminAccess'

const EXPORT_PATTERN = /(엑셀|Excel|CSV|내보내기|다운로드)/i
const APPROVE_PATTERN = /(승인|반려|확정|이용 제한|요청 종료|블라인드|복구|완전 삭제|심사 완료|심사 반려|정산 처리|지급 처리|정지 해제)/
const EDIT_PATTERN = /(추가|등록|작성|수정|편집|삭제|초대|저장|생성|변경|활성화|비활성화|중지|발행|지정|새 운영 공지)/
const NAVIGATION_EXCEPTIONS = /(보기|미리보기|상세|이동|돌아가기|전체 실행 이력|사후관리|로그아웃|메뉴 닫기|대시보드)/

function requiredAction(button) {
  const label = button.textContent?.replace(/\s+/g, ' ').trim() || ''
  if (!label) return null
  if (EXPORT_PATTERN.test(label)) return 'export'
  if (APPROVE_PATTERN.test(label)) return 'approve'
  if (!NAVIGATION_EXCEPTIONS.test(label) && EDIT_PATTERN.test(label)) return 'edit'
  return null
}

function applyPermission(button, route) {
  const action = requiredAction(button)
  if (!action) return
  const allowed = currentAdminCan(route, action)
  button.disabled = !allowed
  button.setAttribute('aria-disabled', allowed ? 'false' : 'true')
  if (!allowed) {
    button.dataset.permissionBlocked = action
    button.title = action === 'export'
      ? '이 계정에는 다운로드 권한이 없습니다.'
      : action === 'approve'
        ? '이 계정에는 승인·처리 권한이 없습니다.'
        : '이 계정에는 등록·수정 권한이 없습니다.'
  } else if (button.dataset.permissionBlocked) {
    delete button.dataset.permissionBlocked
    if (button.title?.includes('권한이 없습니다')) button.removeAttribute('title')
  }
}

export default function AdminActionPermissionEnhancer({ route }) {
  useEffect(() => {
    const root = document.querySelector('.admin-content') || document.body
    const refresh = () => root.querySelectorAll('button').forEach((button) => applyPermission(button, route))
    refresh()
    const observer = new MutationObserver(refresh)
    observer.observe(root, { childList: true, subtree: true })
    return () => observer.disconnect()
  }, [route])
  return null
}
